export default __webpack_public_path__ + "f2ea48e080d881e7701316d12f1ec03d.jpg";